module.exports = __webpack_public_path__ + "static/media/fast_bet_third.405756b3.mp3";